"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.heading.chat': 'Inizia a parlare con il tuo assistente IA',
    'chat.heading.ask': 'Fai la tua domanda',
};
